import { render } from "./routerregister.vue?vue&type=template&id=10cee0b5"
import script from "./routerregister.vue?vue&type=script&lang=js"
export * from "./routerregister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__